module.exports = __webpack_public_path__ + "assets/img/loginLeftImg.d7057756.png";